export default __webpack_public_path__ + "static/favicon-e7026416a02c422ad1a986c5236d42d0.png";